exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrField-zo3bR{margin-bottom:20px}.labelField-25p9Z{padding-right:5px;color:#39395b;opacity:.4;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"wrField": "wrField-zo3bR",
	"labelField": "labelField-25p9Z"
};